import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { customStyles } from "./index.styles";
import { serviceList } from "../../../shared/utils/constants";

interface Props {
  id: string;
}

const ServicesSection = ({ id }: Props) => {
  return (
    <>
      <Box id={id} mt={6} px={4}>
        <Typography variant="h3" sx={customStyles.text}>
          Our Services
        </Typography>
      </Box>

      <Box px={4} display="flex" justifyContent="center">
        <Grid
          container
          spacing={3}
          mt={2}
          display="flex"
          justifyContent="center"
          width="90vw"
        >
          {serviceList.map((service, index) => (
            <Grid
              xs={12}
              sm={6}
              md={3}
              key={index}
              item
              display="flex"
              justifyContent="center"
            >
              <Card sx={customStyles.card}>
                <CardMedia
                  component="img"
                  height="200"
                  image={service.image}
                  sx={{ objectFit: "cover", zoom: 1.5 }}
                />

                <CardContent sx={customStyles.cardContent}>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={customStyles.cardHeading}
                  >
                    {service.name}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ ...customStyles.shortDescription, mb: 2 }}
                  >
                    {service.shortDescription}
                  </Typography>

                  <Button
                    component={Link}
                    to={`/service/${service.id}`}
                    variant="text"
                    size="small"
                    sx={customStyles.seeMoreButton}
                  >
                    See More →
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default ServicesSection;
